import PropTypes from 'prop-types';
import React from 'react';

import {useSelector} from 'react-redux';
import {i18n} from 'src/i18n';
import selectors from 'src/modules/perfilEmpleado/perfilEmpleadoSelectors';
import DrawerButton from 'src/view/shared/view/DrawerButton';
import PerfilEmpleadoView from '../view/PerfilEmpleadoView';

function PerfilEmpleadoListItem(props) {
  const hasPermissionToRead = useSelector(selectors.selectPermissionToRead);

  const valueAsArray = () => {
    const {value} = props;

    if (!value) {
      return [];
    }

    if (Array.isArray(value)) {
      return value;
    }

    return [value];
  };

  const displayableRecord = (record) => {
    return (
      <div key={record.id}>
        <DrawerButton
          drawerId={'DrawerPerfilEmpleadoViewPage'}
          type={props.type || 'chip'}
          entity={'perfilEmpleado'}
          tooltipTitle={i18n(record.titulo)}
          buttonTitle={i18n(record.titulo)}
          width={window.innerWidth * 0.55}
          record={record}
          label={props.label}
          contractorsView={props.contractorsView}
          component={<PerfilEmpleadoView record={record} drawer={true} contractorsView={props.contractorsView} />}
        />
      </div>
    );
  };

  if (!valueAsArray().length) {
    return null;
  }

  return <>{valueAsArray().map((value) => displayableRecord(value))}</>;
}

PerfilEmpleadoListItem.propTypes = {
  value: PropTypes.any,
  contractorsView: PropTypes.bool,
  type: PropTypes.string,
  label: PropTypes.string,
};

export default PerfilEmpleadoListItem;
